// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Büyük ekranlar için */
.desktop-container {
  height: 150px;
  margin-top: -30px;
  display: flex;
  justify-content: space-between;
  align-items: start;
  background: linear-gradient(to bottom, #c0bbb7 10%, #f4efea, #ffffff);
}

/* Küçük ekranlar için özel konteyner */
.mobile-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  background-color: #f4efea;
  padding: 10px;
  border-radius: 29px;
  margin: 10px;
  margin-top: 37px;
}

/* İçerik stilini ortak kullanıyoruz */
.user-page {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

/* Logo boyutu */
.logo {
  width: 220px;
  margin-top: 40px;
  padding-left: 44px;
  cursor: pointer;
  /* Tıklanabilir olduğunu göster */
}

/* Ayarlar butonu alanı */
.settings-container {
  padding-top: 50px;
  margin-right: 18px;
  display: flex;
  align-items: center;
  gap: 20px;
}

/* Butonların ortak stilleri */
.settings-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 162px;
  height: 48px;
  background: #625480;
  border-radius: 50px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.settings-button img {
  padding-left: 8px;
}

/* Kullanıcı profil ikonu */
.profile-icon {
  width: 96px;
  height: 96px;
  border: 3px solid #625480;
  border-radius: 50%;
  background: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-left: 15px;
  overflow: hidden;
  /* Resmin dışarı taşmasını engeller */
  cursor: pointer;
  /* Tıklanabilir olduğunu göster */
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  /* Hover animasyonu */
}

/* Profil ikonu hover efekti */
.profile-icon:hover {
  transform: scale(1.05);
  /* Hafif büyütme */
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  /* Daha belirgin gölge */
}

/* Profil resmi */
.profile-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

/* Admin Panel başlığı kapsayıcısı */
.admin-title-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 100px;
  margin-right: 269px;
}

/* Admin Panel başlığı */
.admin-title {
  font-size: 32px;
  font-weight: bold;
  color: #024202;
  text-align: center;
  width: auto;
  font-family: Manrope;
}

/* Küçük ekranlara özel stil */
@media (max-width: 768px) {
  .logo {
    width: 150px;
    height: 80px;
    margin-top: 5px;
    margin-left: -55px;
  }

  .settings-container {
    padding-top: 0px;
    margin-right: 0px;
  }

  .settings-button {
    width: 77px;
    height: 23px;
  }

  .settings-button img {
    width: 23px;
    height: 20px;
  }

  .profile-icon {
    width: 40px;
    height: 40px;
    border-width: 2px;
  }

  .profile-icon img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .admin-title-container {
    width: 100px;
    margin-top: 0px;
  }

  .admin-title {
    font-size: 15px;
    width: 100px;
  }
}`, "",{"version":3,"sources":["webpack://./src/common/UserPage/UserPage.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,qEAAqE;AACvE;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,iCAAiC;EACjC,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;EAC1C,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,oBAAoB;AACtB;;AAEA,8BAA8B;AAC9B;EACE;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF","sourcesContent":["/* Büyük ekranlar için */\n.desktop-container {\n  height: 150px;\n  margin-top: -30px;\n  display: flex;\n  justify-content: space-between;\n  align-items: start;\n  background: linear-gradient(to bottom, #c0bbb7 10%, #f4efea, #ffffff);\n}\n\n/* Küçük ekranlar için özel konteyner */\n.mobile-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 50px;\n  background-color: #f4efea;\n  padding: 10px;\n  border-radius: 29px;\n  margin: 10px;\n  margin-top: 37px;\n}\n\n/* İçerik stilini ortak kullanıyoruz */\n.user-page {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n/* Logo boyutu */\n.logo {\n  width: 220px;\n  margin-top: 40px;\n  padding-left: 44px;\n  cursor: pointer;\n  /* Tıklanabilir olduğunu göster */\n}\n\n/* Ayarlar butonu alanı */\n.settings-container {\n  padding-top: 50px;\n  margin-right: 18px;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n/* Butonların ortak stilleri */\n.settings-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 162px;\n  height: 48px;\n  background: #625480;\n  border-radius: 50px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.settings-button img {\n  padding-left: 8px;\n}\n\n/* Kullanıcı profil ikonu */\n.profile-icon {\n  width: 96px;\n  height: 96px;\n  border: 3px solid #625480;\n  border-radius: 50%;\n  background: white;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  margin-left: 15px;\n  overflow: hidden;\n  /* Resmin dışarı taşmasını engeller */\n  cursor: pointer;\n  /* Tıklanabilir olduğunu göster */\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  /* Hover animasyonu */\n}\n\n/* Profil ikonu hover efekti */\n.profile-icon:hover {\n  transform: scale(1.05);\n  /* Hafif büyütme */\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n  /* Daha belirgin gölge */\n}\n\n/* Profil resmi */\n.profile-icon img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n/* Admin Panel başlığı kapsayıcısı */\n.admin-title-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-top: 100px;\n  margin-right: 269px;\n}\n\n/* Admin Panel başlığı */\n.admin-title {\n  font-size: 32px;\n  font-weight: bold;\n  color: #024202;\n  text-align: center;\n  width: auto;\n  font-family: Manrope;\n}\n\n/* Küçük ekranlara özel stil */\n@media (max-width: 768px) {\n  .logo {\n    width: 150px;\n    height: 80px;\n    margin-top: 5px;\n    margin-left: -55px;\n  }\n\n  .settings-container {\n    padding-top: 0px;\n    margin-right: 0px;\n  }\n\n  .settings-button {\n    width: 77px;\n    height: 23px;\n  }\n\n  .settings-button img {\n    width: 23px;\n    height: 20px;\n  }\n\n  .profile-icon {\n    width: 40px;\n    height: 40px;\n    border-width: 2px;\n  }\n\n  .profile-icon img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .admin-title-container {\n    width: 100px;\n    margin-top: 0px;\n  }\n\n  .admin-title {\n    font-size: 15px;\n    width: 100px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
